import {Action, Reducer} from '@reduxjs/toolkit'
import {ActivityModel} from './models/ActivityModel'
import {FleksupService} from '../services/FleksupService'
import {batchActions} from 'redux-batched-actions'

import {all, call, put, takeEvery} from 'redux-saga/effects'
import {
  ECOMMERCE_INTEGRATION_TYPE,
  ERP_INTEGRATION_TYPE,
  ORDER_INTEGRATION_TYPE,
  PRICE_INTEGRATION_TYPE,
  PRODUCT_INTEGRATION_TYPE,
  STOCK_INTEGRATION_TYPE,
} from '../constants'
export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export const actionTypes: any = {
  REQUEST_ACTIVITIES: 'REQUEST_ACTIVITIES',
  SUCCESS_ACTIVITIES: 'SUCCESS_ACTIVITIES',
  ERROR_ACTIVITIES: 'ERROR_ACTIVITIES',
  REQUEST_MISS_SETTINGS_BY_KEY: 'REQUEST_MISS_SETTINGS_BY_KEY',
  SUCCESS_MISS_SETTINGS_BY_KEY: 'SUCCESS_MISS_SETTINGS_BY_KEY',
  ERROR_MISS_SETTINGS_BY_KEY: 'ERROR_MISS_SETTINGS_BY_KEY',
  REQUEST_FOR_MISSING_VALIDATION: 'REQUEST_FOR_MISSING_VALIDATION',
  [`REQUEST_${PRODUCT_INTEGRATION_TYPE}_SETTINGS`]: `REQUEST_${PRODUCT_INTEGRATION_TYPE}_SETTINGS`,
  [`SUCCESS_${PRODUCT_INTEGRATION_TYPE}_SETTINGS`]: `SUCCESS_${PRODUCT_INTEGRATION_TYPE}_SETTINGS`,
  [`ERROR_${PRODUCT_INTEGRATION_TYPE}}_SETTINGS`]: `ERROR_${PRODUCT_INTEGRATION_TYPE}}_SETTINGS`,

  [`REQUEST_${ORDER_INTEGRATION_TYPE}_SETTINGS`]: `REQUEST_${ORDER_INTEGRATION_TYPE}_SETTINGS`,
  [`SUCCESS_${ORDER_INTEGRATION_TYPE}_SETTINGS`]: `SUCCESS_${ORDER_INTEGRATION_TYPE}_SETTINGS`,
  [`ERROR_${ORDER_INTEGRATION_TYPE}}_SETTINGS`]: `ERROR_${ORDER_INTEGRATION_TYPE}}_SETTINGS`,

  [`REQUEST_${STOCK_INTEGRATION_TYPE}_SETTINGS`]: `REQUEST_${STOCK_INTEGRATION_TYPE}_SETTINGS`,
  [`SUCCESS_${STOCK_INTEGRATION_TYPE}_SETTINGS`]: `SUCCESS_${STOCK_INTEGRATION_TYPE}_SETTINGS`,
  [`ERROR_${STOCK_INTEGRATION_TYPE}}_SETTINGS`]: `ERROR_${STOCK_INTEGRATION_TYPE}}_SETTINGS`,

  [`REQUEST_${PRICE_INTEGRATION_TYPE}_SETTINGS`]: `REQUEST_${PRICE_INTEGRATION_TYPE}_SETTINGS`,
  [`SUCCESS_${PRICE_INTEGRATION_TYPE}_SETTINGS`]: `SUCCESS_${PRICE_INTEGRATION_TYPE}_SETTINGS`,
  [`ERROR_${PRICE_INTEGRATION_TYPE}}_SETTINGS`]: `ERROR_${PRICE_INTEGRATION_TYPE}}_SETTINGS`,

  [`REQUEST_${ERP_INTEGRATION_TYPE}_SETTINGS`]: `REQUEST_${ERP_INTEGRATION_TYPE}_SETTINGS`,
  [`SUCCESS_${ERP_INTEGRATION_TYPE}_SETTINGS`]: `SUCCESS_${ERP_INTEGRATION_TYPE}_SETTINGS`,
  [`ERROR_${ERP_INTEGRATION_TYPE}}_SETTINGS`]: `ERROR_${ERP_INTEGRATION_TYPE}}_SETTINGS`,

  [`REQUEST_${ECOMMERCE_INTEGRATION_TYPE}_SETTINGS`]: `REQUEST_${ECOMMERCE_INTEGRATION_TYPE}_SETTINGS`,
  [`SUCCESS_${ECOMMERCE_INTEGRATION_TYPE}_SETTINGS`]: `SUCCESS_${ECOMMERCE_INTEGRATION_TYPE}_SETTINGS`,
  [`ERROR_${ECOMMERCE_INTEGRATION_TYPE}}_SETTINGS`]: `ERROR_${ECOMMERCE_INTEGRATION_TYPE}}_SETTINGS`,
  REQUEST_NOTIFICATIONS: 'REQUEST_NOTIFICATIONS',
  SUCCESS_NOTIFICATIONS: 'SUCCESS_NOTIFICATIONS',
  ERROR_NOTIFICATIONS: 'ERROR_NOTIFICATIONS',
  REQUEST_NOTIFICATIONS_COUNT: 'REQUEST_NOTIFICATIONS_COUNT',
  SUCCESS_NOTIFICATIONS_COUNT: 'SUCCESS_NOTIFICATIONS_COUNT',
  ERROR_NOTIFICATIONS_COUNT: 'ERROR_NOTIFICATIONS_COUNT',
  REQUEST_TICKETS: 'REQUEST_TICKETS',
  SUCCESS_TICKETS: 'SUCCESS_TICKETS',
  ERROR_TICKETS: 'ERROR_TICKETS',
  REQUEST_SETTING_LAYOUT: 'REQUEST_SETTING_LAYOUT',
  SUCCESS_SETTING_LAYOUT: 'SUCCESS_SETTING_LAYOUT',
  ERROR_SETTING_LAYOUT: 'ERROR_SETTING_LAYOUT',
}

const initialAuthState: IAppState = {
  activities: {
    isLoading: false,
    data: [],
    error: null,
  },
  settings: {
    isLoading: false,
    data: [],
    error: null,
  },
  [PRODUCT_INTEGRATION_TYPE]: {
    isLoaded: false,
    data: [],
    error: null,
  },
  [ORDER_INTEGRATION_TYPE]: {
    isLoaded: false,
    data: [],
    error: null,
  },
  [PRICE_INTEGRATION_TYPE]: {
    isLoaded: false,
    data: [],
    error: null,
  },
  [STOCK_INTEGRATION_TYPE]: {
    isLoaded: false,
    data: [],
    error: null,
  },
  [ERP_INTEGRATION_TYPE]: {
    isLoaded: false,
    data: [],
    error: null,
  },
  [ECOMMERCE_INTEGRATION_TYPE]: {
    isLoaded: false,
    data: [],
    error: null,
  },
  notifications: {
    isLoading: false,
    data: [],
    error: null,
  },
  notificationsCount: {
    isLoading: false,
    data: 0,
    error: null,
  },
  tickets: {
    isLoading: false,
    data: [],
    error: null,
  },
  settingLayout: {
    isLoading: false,
    data: null,
    error: null,
  },
}

export interface IAppState {
  activities?: ActivityModel
  settings?: any
  [PRODUCT_INTEGRATION_TYPE]?: any
  [ORDER_INTEGRATION_TYPE]?: any
  [PRICE_INTEGRATION_TYPE]?: any
  [STOCK_INTEGRATION_TYPE]?: any
  [ERP_INTEGRATION_TYPE]?: any
  [ECOMMERCE_INTEGRATION_TYPE]?: any
  notifications?: any
  notificationsCount?: any
  tickets?: any
  settingLayout?: any
}

export const reducer: Reducer = (state: any = initialAuthState, action: any): any => {
  switch (action.type) {
    case actionTypes.REQUEST_ACTIVITIES: {
      return {
        ...state,
        activities: {
          isLoading: true,
          data: [],
          ...state.activities,
        },
      }
    }
    case actionTypes.SUCCESS_ACTIVITIES: {
      const activities = {
        ...state.activities,
        isLoading: false,
        data: action.payload.activities,
      }
      return {
        ...state,
        activities,
      }
    }
    case actionTypes.REQUEST_MISS_SETTINGS_BY_KEY: {
      return {
        ...state,
        settings: {
          isLoading: true,
          data: [],
          ...state.settings,
        },
      }
    }
    case actionTypes.SUCCESS_MISS_SETTINGS_BY_KEY: {
      const settings = {
        ...state.settings,
        isLoading: false,
        data: action.payload.settings,
      }
      return {
        ...state,
        settings,
      }
    }
    case actionTypes[`REQUEST_${action.type}_SETTINGS`]: {
      return {
        ...state,
        [action.type]: {
          data: [],
          ...state[action.type],
        },
      }
    }
    case actionTypes[`SUCCESS_${action.payload?.type}_SETTINGS`]: {
      const integrationSettings = {
        ...state[action.payload.type],
        isLoaded: true,
        data: action.payload.data,
      }
      return {
        ...state,
        [action.payload.type]: integrationSettings,
      }
    }
    case actionTypes[`ERROR_${action.payload?.type}_SETTINGS`]: {
      const integrationSettings = {
        ...state[action.payload.type],
        isLoading: true,
        data: [],
      }
      return {
        ...state,
        [action.payload.type]: integrationSettings,
      }
    }
    case actionTypes.REQUEST_NOTIFICATIONS: {
      return {
        ...state,
        notifications: {
          isLoading: true,
          data: [],
          ...state.notifications,
        },
      }
    }
    case actionTypes.SUCCESS_NOTIFICATIONS: {
      const notifications = {
        ...state.notifications,
        isLoading: false,
        data: action.payload.notifications,
      }
      return {
        ...state,
        notifications,
      }
    }

    case actionTypes.REQUEST_NOTIFICATIONS_COUNT: {
      return {
        ...state,
        notificationsCount: {
          isLoading: true,
          data: [],
          ...state.notificationsCount,
        },
      }
    }
    case actionTypes.SUCCESS_NOTIFICATIONS_COUNT: {
      const notificationsCount = {
        ...state.notificationsCount,
        isLoading: false,
        data: action.payload.notificationsCount,
      }
      return {
        ...state,
        notificationsCount,
      }
    }

    case actionTypes.REQUEST_TICKETS: {
      return {
        ...state,
        tickets: {
          isLoading: true,
          data: [],
          ...state.tickets,
        },
      }
    }
    case actionTypes.SUCCESS_TICKETS: {
      const tickets = {
        ...state.tickets,
        isLoading: false,
        data: action.payload.tickets,
      }
      return {
        ...state,
        tickets,
      }
    }
    case actionTypes.REQUEST_SETTING_LAYOUT: {
      return {
        ...state,
        settingLayout: {
          isLoading: true,
          data: [],
          ...state.settingLayout,
        },
      }
    }
    case actionTypes.SUCCESS_SETTING_LAYOUT: {
      const settingLayout = {
        ...state.settingLayouts,
        isLoading: false,
        data: action.payload.settingLayouts,
      }
      return {
        ...state,
        settingLayout,
      }
    }
    default:
      return state
  }
}
export const actions = {
  getActivitiesRequest: (pageNumber: number, pageSize: number) => {
    return {
      type: actionTypes.REQUEST_ACTIVITIES,
      payload: {
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    }
  },
  getActivitiesRequestSuccess: (data: any) => {
    return {
      type: actionTypes.SUCCESS_ACTIVITIES,
      payload: {
        activities: data,
      },
    }
  },
  getMissSettingsByKeysRequest: (keys: any) => {
    return {
      type: actionTypes.REQUEST_MISS_SETTINGS_BY_KEY,
      payload: {
        keys: keys,
      },
    }
  },
  getMissSettingsByKeysSuccess: (data: any) => {
    return {
      type: actionTypes.SUCCESS_MISS_SETTINGS_BY_KEY,
      payload: {
        settings: data,
      },
    }
  },
  getForMissingValidationRequest: () => {
    return {
      type: actionTypes.REQUEST_FOR_MISSING_VALIDATION,
    }
  },
  getMissSettingsByTypeSuccess: (data: any, type: any) => {
    return {
      type: actionTypes[`SUCCESS_${type}_SETTINGS`],
      payload: {
        data: data,
        type: type,
      },
    }
  },
  getNotificationsRequest: (pageNumber: number, pageSize: number) => {
    return {
      type: actionTypes.REQUEST_NOTIFICATIONS,
      payload: {
        pageNumber: pageNumber,
        pageSize: pageSize,
      },
    }
  },
  getNotificationsRequestSuccess: (data: any) => {
    return {
      type: actionTypes.SUCCESS_NOTIFICATIONS,
      payload: {
        notifications: data,
      },
    }
  },
  getNotificationsCountRequest: () => {
    return {
      type: actionTypes.REQUEST_NOTIFICATIONS_COUNT,
    }
  },
  getNotificationsCountRequestSuccess: (data: any) => {
    return {
      type: actionTypes.SUCCESS_NOTIFICATIONS_COUNT,
      payload: {
        notificationsCount: data,
      },
    }
  },
  getTicketsRequest: (filters: any) => {
    return {
      type: actionTypes.REQUEST_TICKETS,
      payload: filters,
    }
  },
  getTicketsRequestSuccess: (data: any) => {
    return {
      type: actionTypes.SUCCESS_TICKETS,
      payload: {
        tickets: data,
      },
    }
  },
  getSettingLayoutRequest: () => {
    return {
      type: actionTypes.REQUEST_SETTING_LAYOUT,
    }
  },
  getSettingLayoutRequestSuccess: (data: any) => {
    return {
      type: actionTypes.SUCCESS_SETTING_LAYOUT,
      payload: {
        settingLayouts: data,
      },
    }
  },
}

function* fetchActivities(action: any): any {
  try {
    const response = yield call(
      FleksupService.getActivities,
      action.payload.pageNumber,
      action.payload.pageSize
    )
    yield put(actions.getActivitiesRequestSuccess(response.data.data))
  } catch (e: any) {
    yield put({type: actionTypes.ERROR_ACTIVITIES, message: e.message})
  }
}

function* fetchSettingsByKeys(action: any): any {
  try {
    const response = yield call(FleksupService.getSettingsByKeyList, action.payload.keys)
    yield put(actions.getMissSettingsByKeysSuccess(response.data.data))
  } catch (e: any) {
    yield put({type: actionTypes.ERROR_MISS_SETTINGS_BY_KEY, message: e.message})
  }
}

function* fetchSettingsByTypes(action: any): any {
  try {
    const [
      productIntegrationRes,
      orderIntegrationRes,
      stockIntegrationRes,
      priceIntegrationRes,
      erpIntegrationRes,
      eCommerceIntegrationRes,
    ] = yield all([
      call(FleksupService.getSettingsByType, PRODUCT_INTEGRATION_TYPE),
      call(FleksupService.getSettingsByType, ORDER_INTEGRATION_TYPE),
      call(FleksupService.getSettingsByType, STOCK_INTEGRATION_TYPE),
      call(FleksupService.getSettingsByType, PRICE_INTEGRATION_TYPE),
      call(FleksupService.getSettingsByType, ERP_INTEGRATION_TYPE),
      call(FleksupService.getSettingsByType, ECOMMERCE_INTEGRATION_TYPE),
    ])

    yield put(
      batchActions([
        actions.getMissSettingsByTypeSuccess(
          productIntegrationRes.data.data,
          PRODUCT_INTEGRATION_TYPE
        ),
        actions.getMissSettingsByTypeSuccess(orderIntegrationRes.data.data, ORDER_INTEGRATION_TYPE),
        actions.getMissSettingsByTypeSuccess(stockIntegrationRes.data.data, STOCK_INTEGRATION_TYPE),
        actions.getMissSettingsByTypeSuccess(priceIntegrationRes.data.data, PRICE_INTEGRATION_TYPE),
        actions.getMissSettingsByTypeSuccess(erpIntegrationRes.data.data, ERP_INTEGRATION_TYPE),
        actions.getMissSettingsByTypeSuccess(
          eCommerceIntegrationRes.data.data,
          ECOMMERCE_INTEGRATION_TYPE
        ),
      ])
    )
  } catch (e: any) {
    yield put({type: actionTypes[`ERROR_${action.payload.type}}_SETTINGS`], message: e.message})
  }
}

function* fetchNotifications(action: any): any {
  try {
    const response = yield call(
      FleksupService.getNotifications,
      action.payload.pageNumber,
      action.payload.pageSize
    )
    yield put(actions.getNotificationsRequestSuccess(response.data.data.dataList))
  } catch (e: any) {
    yield put({type: actionTypes.ERROR_NOTIFICATIONS, message: e.message})
  }
}

function* fetchNotificationsCount(action: any): any {
  try {
    const response = yield call(FleksupService.getUnreadNotificationsCount)
    yield put(actions.getNotificationsCountRequestSuccess(response.data.data))
  } catch (e: any) {
    yield put({type: actionTypes.ERROR_NOTIFICATIONS_COUNT, message: e.message})
  }
}

function* fetchTickets(action: any): any {
  try {
    const response = yield call(FleksupService.getTicketList, {
      pageNumber: action.payload.pageNumber,
      pageSize: action.payload.pageSize,
      orderBy: action.payload.orderBy,
    })

    yield put(actions.getTicketsRequestSuccess(response.data?.data?.dataList))
  } catch (e: any) {
    yield put({type: actionTypes.ERROR_TICKETS, message: e.message})
  }
}

function* fetchSettingLayout(): any {
  try {
    const settingLayout = yield call(FleksupService.getSettingsLayout)
    const licence = yield call(FleksupService.getLicence)
    yield put(
      actions.getSettingLayoutRequestSuccess({
        LicenceInfo: licence.data.data,
        ...settingLayout.data,
      })
    )
  } catch (e: any) {
    yield put({type: actionTypes.ERROR_SETTING_LAYOUT, message: e.message})
  }
}

export function* saga() {
  yield takeEvery(actionTypes.REQUEST_ACTIVITIES, fetchActivities)
  yield takeEvery(actionTypes.REQUEST_SETTING_LAYOUT, fetchSettingLayout)
  yield takeEvery(actionTypes.REQUEST_MISS_SETTINGS_BY_KEY, fetchSettingsByKeys)
  yield takeEvery(actionTypes.REQUEST_FOR_MISSING_VALIDATION, fetchSettingsByTypes)
  yield takeEvery(actionTypes.REQUEST_NOTIFICATIONS, fetchNotifications)
  yield takeEvery(actionTypes.REQUEST_NOTIFICATIONS_COUNT, fetchNotificationsCount)
  yield takeEvery(actionTypes.REQUEST_TICKETS, fetchTickets)
}
